@if (isDevToolsEnabled()) {
  <div class="fixed bottom-2 right-2 z-9999">
    <p-button
      (onClick)="toggleDevMenu($event)"
      severity="contrast"
      size="small"
      outlined
      [pTooltip]="'Developer Tools'"
      tooltipPosition="left"
      styleClass="bg-red-600! border-red-600! text-white! hover:bg-red-700! hover:border-red-700! shadow-lg!"
    >
      <ng-template #icon>
        <fa-icon [icon]="['fas', 'code']" [fixedWidth]="true" class="text-white" />
      </ng-template>
    </p-button>
  </div>
  <p-tieredmenu
    #devMenu
    [popup]="true"
    [model]="devMenuItems()"
    [styleClass]="'w-[280px] shadow-2xl! border-2! border-red-500!'"
  >
    <ng-template pTemplate="item" let-item>
      @if (item.separator) {
        <div class="border-t border-red-200 my-2"></div>
      } @else if (item.header) {
        <div class="px-3 py-2 bg-red-50 font-semibold text-red-800 text-sm uppercase tracking-wide">
          {{ item.label }}
        </div>
      } @else {
        <a
          (click)="item.command ? item.command($event) : null"
          class="p-tieredmenu-item-link flex justify-between pr-3! pl-3 w-full! cursor-pointer items-center h-10 hover:bg-red-50"
        >
          <span class="flex items-center gap-3">
            <span class="text-sm" [ngClass]="{ 'text-red-600 font-medium': item.active && item.active() }">
              {{ item.label }}
            </span>
          </span>

          @if (item.active && item.active()) {
            <fa-icon [icon]="['fas', 'check']" [fixedWidth]="true" class="text-red-600" />
          }
        </a>
      }
    </ng-template>
  </p-tieredmenu>
}
